import {
  Eye,
  Heart,
  MessageSquareMore,
  Percent,
  Share,
  ThumbsDown,
  ThumbsUp,
  Users,
} from 'lucide-react';
import type { ReactNode } from 'react';

import Typo from '@/components/Typography/Typo';
import { Tooltip } from '@/shared/ui/tooltip';

import type {
  FeedbackGalleryEngagementItem,
  FeedbackGalleryEngagementKey,
} from '../model/feedback-gallery-card-view-model';

type FeedbackGalleryCardEngagementProps = {
  engagementItems: FeedbackGalleryEngagementItem[];
  getTooltipContent: (label: string, value: string) => ReactNode;
  formatEngagementValue: (
    itemKey: FeedbackGalleryEngagementKey,
    value: number,
  ) => string;
};

const buildEngagementIcon = (itemKey: FeedbackGalleryEngagementKey) => {
  const iconClassName = 'text-gray-600';

  switch (itemKey) {
    case 'subscribe_count':
      return <Users size={12} className={iconClassName} />;
    case 'view_count':
      return <Eye size={12} className={iconClassName} />;
    case 'comment_count':
      return <MessageSquareMore size={12} className={iconClassName} />;
    case 'like_count':
      return <Heart size={12} className={iconClassName} />;
    case 'votes_up_count':
      return <ThumbsUp size={12} className={iconClassName} />;
    case 'votes_down_count':
      return <ThumbsDown size={12} className={iconClassName} />;
    case 'share_count':
      return <Share size={12} className={iconClassName} />;
    case 'rate':
      return <Percent size={12} className={iconClassName} />;
    default:
      return null;
  }
};

const FeedbackGalleryCardEngagement = ({
  engagementItems,
  getTooltipContent,
  formatEngagementValue,
}: FeedbackGalleryCardEngagementProps) => {
  if (engagementItems.length === 0) return null;

  return (
    <div className="space-y-2 px-4 py-3">
      <div className="flex flex-wrap gap-3">
        {engagementItems.map((item) => (
          <Tooltip
            key={item.key}
            disableHoverableContent
            content={getTooltipContent(
              item.label,
              formatEngagementValue(item.key, item.value),
            )}
          >
            <div className="flex items-center gap-1">
              {buildEngagementIcon(item.key)}
              <Typo type="label3" className="text-gray-700">
                {formatEngagementValue(item.key, item.value)}
              </Typo>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};

export default FeedbackGalleryCardEngagement;
